import { SideviewContext } from "context/SideviewContext";
import { useContext, useEffect } from "react";
import SlidingPanel from "react-sliding-side-panel";
import "react-sliding-side-panel/lib/index.css";
import EditFormSite from "ui/sites/edit-form";
import EditFormNvr from "ui/nvrs/edit-form";
import EditFormCamera from "ui/cameras/edit-form";
import EditFormIPSpeaker from "ui/ip-speaker/edit-form";

import { SvgClose } from "ui/svgs";

export function SlidingView() {
  const { setOpenPanel, openPanel, viewData } = useContext(SideviewContext);
  console.log("viewData = ", viewData);

  if (viewData) {
    return (
      <SlidingPanel
        type={"right"}
        isOpen={openPanel}
        size={30}
        panelClassName="bg-white px-6 py-4"
        panelContainerClassName="z-auto"
        backdropClicked={() => setOpenPanel(false)}
      >
        <div className="overflow-y-auto">
          <div className="flex justify-between pt-3 mb-6">
            <p className="text-xl">{viewData.title}</p>
            <button onClick={() => setOpenPanel(false)}>
              <SvgClose width={"16"} />
            </button>
          </div>
          {viewData && viewData.type === "edit-site" && (
            <EditFormSite
              orgId={viewData.orgId}
              siteId={viewData.siteId}
              objData={viewData.objData}
            />
          )}
          {viewData && viewData.type === "edit-nvr" && (
            <EditFormNvr
              orgId={viewData.orgId}
              siteId={viewData.siteId}
              objData={viewData.objData}
            />
          )}
          {viewData && viewData.type === "edit-ipc" && (
            <EditFormCamera
              orgId={viewData.orgId}
              siteId={viewData.siteId}
              objData={viewData.objData}
            />
          )}
          {viewData && viewData.type === "edit-ipspeaker" && (
            <EditFormIPSpeaker
              orgId={viewData.orgId}
              siteId={viewData.siteId}
              objData={viewData.objData}
            />
          )}
        </div>
      </SlidingPanel>
    );
  }
}
